import React from 'react';
import {observer, inject} from 'mobx-react';
import {injectIntl} from 'react-intl';
import FeedbackChain from './models/FeedbackChain';
import {SplitButton, MenuItem} from 'react-bootstrap';
import FeedbackPriority from './FeedbackPriority';

@injectIntl @inject('authorizationsStore') @observer
export default class PrioritiesToolbar extends React.Component{

    render(){
        const {feedbackChain, intl} = this.props;
        const priorities = FeedbackChain.priorities;
        return (
            <div className={'toolbar feedback-chain-states'}>
                <div className={"title"}> <i className="fa fa-angle-double-up" />
                    &nbsp;{intl.formatMessage({id:"priority"})}
                </div>
                <div className={'content'}>
                    <SplitButton
                        bsStyle={'default'}
                        title={intl.formatMessage({id: feedbackChain.priority})}
                        key={feedbackChain.priority}
                        id={`split-button-priorities-${feedbackChain.priority}`}
                        disabled={!this.props.authorizationsStore.canEditFeedback(feedbackChain)}
                    >
                        {priorities.map( (p, idx) =>
                            <MenuItem key={idx} className={p} eventKey={p} onSelect={(p) => feedbackChain.setPriority(p)}>
                                <FeedbackPriority priority={p} />&nbsp;{intl.formatMessage({id: p})}
                            </MenuItem>
                        )}
                    </SplitButton>
                </div>
            </div>
        );
    }

    handleClick = (val) => {
        this.props.feedbackChain.priority = val;
    }
}